import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot} from '@angular/router';
import {AuthService} from '@app/_service';
import {RoleType} from "@app/_model";
import {Logger} from "@app/logger";

@Injectable({
  providedIn: 'root'
})
export class RoleGuard {

  private readonly log = new Logger();

  constructor(
    private readonly router: Router,
    private readonly authService: AuthService
  ) {
  }

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const roles = route.data['roles'] as RoleType[];
    if (!roles) {
      return true;
    }
    this.log.trace('roles:', typeof roles, roles, typeof roles[0], roles[0], roles[0] === RoleType.Admin, roles[0] === 'ADMIN');
    if (!this.authService.isLoggedIn) {
      this.log.warn('RoleGuard activated!');
      return false;
    }
    const account = this.authService.accountValue;
    this.log.trace('account:', account);
    this.log.trace('account.roles:', account?.roles);
    const filter = account?.roles?.filter(role => {
      this.log.trace('role:', typeof role, role);
      return roles.includes(role);
    });
    this.log.trace('filter:', filter);
    if (filter == undefined || filter.length == 0) {
      this.log.warn('RoleGuard activated!');
      return false;
    }
    return true;
  }
}
